var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "myskov-login" }, [
    _c("div", { staticClass: "myskov-login__col" }, [
      _c(
        "div",
        { staticClass: "login-fields" },
        [
          _c("h2", {
            domProps: { textContent: _vm._s(_vm.translations.title) }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-fields" },
            [
              _c("input-field", {
                staticClass: "booking-field",
                attrs: {
                  name: _vm.translations.input_firstname,
                  value: _vm.user.firstName
                },
                on: {
                  input: function(val) {
                    return (_vm.user.firstName = val)
                  },
                  enter: _vm.createUser
                }
              }),
              _vm._v(" "),
              _vm.showErrors && _vm.isNotValid && _vm.isNotValid.firstName
                ? _c(
                    "msg-block",
                    { attrs: { type: "error" } },
                    _vm._l(_vm.isNotValid.firstName, function(error) {
                      return _c("p", [
                        _c("b", { domProps: { textContent: _vm._s(error) } })
                      ])
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input-field", {
                staticClass: "booking-field",
                attrs: {
                  name: _vm.translations.input_lastname,
                  value: _vm.user.lastName
                },
                on: {
                  input: function(val) {
                    return (_vm.user.lastName = val)
                  },
                  enter: _vm.createUser
                }
              }),
              _vm._v(" "),
              _vm.showErrors && _vm.isNotValid && _vm.isNotValid.lastName
                ? _c(
                    "msg-block",
                    { attrs: { type: "error" } },
                    _vm._l(_vm.isNotValid.lastName, function(error) {
                      return _c("p", [
                        _c("b", { domProps: { textContent: _vm._s(error) } })
                      ])
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input-field", {
                staticClass: "booking-field",
                attrs: {
                  name: _vm.translations.input_email,
                  value: _vm.user.email,
                  "input-type": "email"
                },
                on: {
                  input: function(val) {
                    return (_vm.user.email = val)
                  },
                  enter: _vm.createUser
                }
              }),
              _vm._v(" "),
              _vm.showErrors && _vm.isNotValid && _vm.isNotValid.email
                ? _c(
                    "msg-block",
                    { attrs: { type: "error" } },
                    _vm._l(_vm.isNotValid.email, function(error) {
                      return _c("p", [
                        _c("b", { domProps: { textContent: _vm._s(error) } })
                      ])
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input-field", {
                staticClass: "booking-field",
                attrs: {
                  name: _vm.translations.input_password,
                  "input-type": "password",
                  value: _vm.user.password
                },
                on: {
                  input: function(val) {
                    return (_vm.user.password = val)
                  },
                  enter: _vm.createUser
                }
              }),
              _vm._v(" "),
              _vm.showErrors && _vm.isNotValid && _vm.isNotValid.password
                ? _c(
                    "msg-block",
                    { attrs: { type: "error" } },
                    _vm._l(_vm.isNotValid.password, function(error) {
                      return _c("p", [
                        _c("b", { domProps: { textContent: _vm._s(error) } })
                      ])
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("input-field", {
                staticClass: "booking-field",
                attrs: {
                  name: _vm.translations.input_password_confirm,
                  "input-type": "password",
                  value: _vm.passwordConfirm
                },
                on: {
                  input: function(val) {
                    return (_vm.passwordConfirm = val)
                  },
                  enter: _vm.createUser
                }
              }),
              _vm._v(" "),
              _vm.showErrors && _vm.isNotValid && _vm.isNotValid.passwordConfirm
                ? _c(
                    "msg-block",
                    { attrs: { type: "error" } },
                    _vm._l(_vm.isNotValid.passwordConfirm, function(error) {
                      return _c("p", [
                        _c("b", { domProps: { textContent: _vm._s(error) } })
                      ])
                    })
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("button", {
            staticClass: "btn btn--positive",
            class: { "item-loading": _vm.loading },
            attrs: { disabled: _vm.loading },
            domProps: { textContent: _vm._s(_vm.translations.create_user_btn) },
            on: { click: _vm.createUser }
          }),
          _vm._v(" "),
          _vm.createError
            ? _c("msg-block", { attrs: { type: "error" } }, [
                _c("p", [
                  _c("b", {
                    domProps: { textContent: _vm._s(_vm.createError) }
                  })
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "myskov-login__col" }, [
      _c(
        "div",
        { staticClass: "login-help" },
        [
          _c("h2", {
            domProps: { textContent: _vm._s(_vm.translations.help_txt_header) }
          }),
          _vm._v(" "),
          _vm._l(_vm.translations.help_txt, function(text) {
            return _c("p", { domProps: { innerHTML: _vm._s(text) } })
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24bfae96", { render: render, staticRenderFns: staticRenderFns })
  }
}